import React, { useEffect, useRef, useState } from 'react';
import './InsuranceInformationStep.scss';
import { getInsuranceData } from "../InsuranceRequests";
import DynaInput from "../../DynaView/DynaInput";
import DynaTextarea from "../../DynaView/DynaTextarea";
import { IranTagSVG } from "../InsuranceSVG/InsuranceSVG";
import DynaDatePicker from "../../DynaView/DynaDatePicker";

const InsuranceInformationStep = ({ sendData, setSendData }) => {

  const [insuranceData, setInsuranceData] = useState([]);
  const [openTag, setOpenTag] = useState(false);
  const [hasPlate, setHasPlate] = useState(false);
  const [newPlate, setNewPlate] = useState(0);
  const [filterText, setFilterText] = useState(""); // برای فیلتر کردن لیست
  const tagBoxRef = useRef(null);

  const arrow = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 6"
  >
    <path
      fill="#B9B9B9"
      d="M6 5.3a1.59 1.59 0 01-1.126-.467L1.07 1.03a.44.44 0 010-.618.44.44 0 01.618 0l3.803 3.803c.28.28.735.28 1.015 0L10.31.412a.44.44 0 01.619 0c.169.169.169.449 0 .618L7.126 4.833A1.59 1.59 0 016 5.3z"
    ></path>
  </svg>

  const iran = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="21"
    fill="none"
    viewBox="0 0 12 21"
  >
    <path
      fill="#484848"
      d="M3.177.693A4.223 4.223 0 014.282.68c.22.02.478.069.775.148.296.083.577.184.842.302.268.12.51.247.727.377l-.56.76a1.872 1.872 0 00-.249-.143 4.353 4.353 0 00-.846-.325 5.167 5.167 0 00-.531-.129 4.7 4.7 0 00-.722-.067c-.14 0-.276.01-.407.029a1.766 1.766 0 00-.65.24 2.037 2.037 0 00-.364.276 1.834 1.834 0 00-.315.402c-.096.16-.172.344-.23.555-.06.214-.09.456-.09.727 0 .338.031.644.095.918s.158.515.282.722a1.827 1.827 0 001.048.837c.274.086.55.133.827.139h.057a4.532 4.532 0 001.454-.24c.223-.073.416-.146.579-.22.166-.073.295-.138.387-.195.096-.054.144-.083.144-.086l.507.794-.206.12c-.118.07-.277.149-.478.238-.198.093-.43.184-.698.273a4.933 4.933 0 01-1.621.273c-.07 0-.208-.005-.412-.015-.207-.01-.483-.072-.827-.186A2.834 2.834 0 011.22 5.93c-.172-.29-.3-.612-.382-.966A4.832 4.832 0 01.714 3.85c0-.408.051-.79.153-1.148.1-.354.25-.67.455-.947.2-.277.456-.508.765-.693.31-.182.673-.305 1.09-.369zM7.09 4.84l-.78-.78.784-.784.78.78-.784.784zm4.462 4.757a43.715 43.715 0 01-3.482.244 57.911 57.911 0 01-2.616 0 21.318 21.318 0 01-1.497-.077l.053-.942a44.47 44.47 0 001.96.1c.268.007.525.01.77.01.297 0 .578-.005.842-.014a59.829 59.829 0 003.826-.258l.144.937zM4.33 13.494c-.418 0-.816-.09-1.196-.268a4.253 4.253 0 01-1.057-.712 6.1 6.1 0 01-.899-1.01 8.74 8.74 0 01-.708-1.171l.847-.412c.118.23.249.458.392.684.14.227.292.44.454.641.163.201.335.386.517.555.179.169.367.31.564.426.198.118.404.205.617.263a1.787 1.787 0 00.646.052c.182-.022.376-.057.583-.105.21-.045.417-.094.617-.148a25.082 25.082 0 001.01-.301l.277.899c-.37.12-.686.239-.947.354-.258.114-.47.232-.636.353a1.316 1.316 0 00-.359.378.871.871 0 00-.115.44v.077H4v-.082c0-.044.002-.101.005-.172a1.151 1.151 0 01.143-.492c.048-.086.115-.17.201-.249H4.33zm.607.815v.923c0 .185.004.365.01.54.01.175.033.338.072.488.038.15.094.282.167.397a.765.765 0 00.316.268.929.929 0 00.253.072c.067.009.139.014.215.014a2.337 2.337 0 00.536-.072c.15-.035.306-.086.469-.153l1.023-.416.421.851c-.003 0-.037.015-.1.043-.06.029-.144.066-.249.11a6.997 6.997 0 01-.808.306c-.463.144-.87.227-1.225.25a2.444 2.444 0 01-.153.004c-.29 0-.545-.048-.765-.144a1.565 1.565 0 01-.54-.382 1.861 1.861 0 01-.345-.54 2.716 2.716 0 01-.181-.675A5.272 5.272 0 014 15.437V14.31h.937zm-2.5 1.664l-.776-.775.78-.784.78.775-.785.784zm-.006 1.96l-.78-.774.785-.784.775.774-.78.785zm9.12 2.16a43.71 43.71 0 01-3.481.243 57.522 57.522 0 01-2.616 0 21.347 21.347 0 01-1.497-.076l.053-.943c.714.051 1.367.085 1.96.1.268.007.525.01.77.01.297 0 .578-.004.842-.014a59.861 59.861 0 003.826-.258l.144.937z"
    ></path>
  </svg>

  useEffect(() => {
    void getInsuranceData(setInsuranceData, sendData, setSendData, setHasPlate)
  }, []);

  const tag = [
    { value: "الف", label: "الف" },
    { value: "ب", label: "ب" },
    { value: "پ", label: "پ" },
    { value: "ت", label: "ت" },
    { value: "ث", label: "ث" },
    { value: "ج", label: "ج" },
    { value: "د", label: "د" },
    { value: "ز", label: "ز" },
    { value: "س", label: "س" },
    { value: "ش", label: "ش" },
    { value: "ص", label: "ص" },
    { value: "ط", label: "ط" },
    { value: "ع", label: "ع" },
    { value: "ف", label: "ف" },
    { value: "ق", label: "ق" },
    { value: "ک", label: "ک" },
    { value: "گ", label: "گ" },
    { value: "ل", label: "ل" },
    { value: "م", label: "م" },
    { value: "ن", label: "ن" },
    { value: "و", label: "و" },
    { value: "ه", label: "ه" },
    { value: "ی", label: "ی" },
    { value: "ژ", label: "معلولین" },
    { value: "تشریفات", label: "تشریفات" },
    { value: "D", label: "D" },
    { value: "S", label: "S" },
  ]

  const filteredTags = tag.filter(item =>
    item.label.toLowerCase().includes(filterText.toLowerCase())
  );

  const inputChanger = (value, name, index) => {
    if (value.length <= 1) {
      setNewPlate(newPlate + 1)
      setSendData({ ...sendData, [name]: value })
    }

    const nextIndex = index + 1;

    if (nextIndex === 3) {
      setOpenTag(true)
    }
    const nextInput = document.getElementById(`input-${nextIndex}`);
    if (nextInput) {
      nextInput.focus();
    }
  }

  const handleBackspace = (e, name, index) => {
    if (e.key === 'Backspace' && index > 0) {
      e.preventDefault();

      setSendData(prevData => ({ ...prevData, [name]: "" }));

      const prevInput = document.getElementById(`input-${index - 1}`);
      prevInput?.focus();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openTag && tagBoxRef.current && !tagBoxRef.current.contains(event.target)) {
        setOpenTag(false);
        setFilterText("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openTag]);

  useEffect(() => {
    setSendData({
      ...sendData,
      plate: sendData?.partOne + sendData?.partTwo + "-" + sendData?.partThree + "-" + sendData?.partFour + sendData?.partFive + sendData?.partSix + "-" + sendData?.partSeven + sendData?.partEight
    })
  }, [newPlate]);

  const plateTypeHandler = (name) => {
    setSendData({
      ...sendData,
      plateType: name,
      partOne: "",
      partTwo: "",
      partThree: "الف",
      partFour: "",
      partFive: "",
      partSix: "",
      partSeven: "",
      partEight: "",
    })
  }

  return (
    <div className={"insurance-information"}>
      <div className={"insurance-number"}>
        <p>شماره بیمه نامه :</p>
        <input
          value={sendData?.insuranceLastNumber}
          onChange={(e) =>
            setSendData({
              ...sendData,
              insuranceLastNumber: e.target.value,
              insuranceNumber: `${sendData?.insuranceNumberYear}/${insuranceData[1]}/${insuranceData[2]}/${insuranceData[3]}/${e.target.value}`,
            })
          }
        />
        <p>/</p>
        <span>{insuranceData[3]}</span>
        <p>/</p>
        <span>{insuranceData[2]}</span>
        <p>/</p>
        <span>{insuranceData[1]}</span>
        <p>/</p>
        <input
          value={sendData?.insuranceNumberYear}
          onChange={(e) => {
            const inputValue = e.target.value;
            // چک شود که فقط عدد وارد شود و صفر به عنوان عدد اول نباشد
            if (!/^\d*$/.test(inputValue) || (inputValue.length === 1 && inputValue === "0")) return;
            setSendData({
              ...sendData,
              insuranceNumber: `${inputValue}/${insuranceData[1]}/${insuranceData[2]}/${insuranceData[3]}/${sendData.insuranceLastNumber}`,
              insuranceNumberYear: inputValue,
            });
          }}
        />
      </div>

      <DynaDatePicker
        label={"تاریخ بیمه نامه :"}
        name={"dateOfIssue"}
        className={"solid-dyna-input"}
        value={sendData?.dateOfIssue}
        setDataFromComponent={(data) => {
          setSendData({ ...sendData, ...data });
        }}
      />

      {hasPlate && (
        <>
          <div className="radio-buttons-container">
            <div className="radio-button">
              <label
                htmlFor="radio1"
                className="radio-button__label"
                style={{ padding: "0", fontWeight: "500" }}
              >
                وسیله نقلیه :
              </label>
            </div>

            <div className="radio-button">
              <input
                name="radio-group1"
                id="radio2"
                className="radio-button__input"
                type="radio"
                checked={sendData?.plateType === "car"}
                onChange={() => plateTypeHandler("car")}
              />
              <label htmlFor="radio2" className="radio-button__label">
                <span className="radio-button__custom"></span>
                ماشین
              </label>
            </div>

            <div className="radio-button">
              <input
                name="radio-group1"
                id="radio1"
                className="radio-button__input"
                type="radio"
                checked={sendData?.plateType === "motor"}
                onChange={() => plateTypeHandler("motor")}
              />
              <label htmlFor="radio1" className="radio-button__label">
                <span className="radio-button__custom"></span>
                موتور
              </label>
            </div>
          </div>

          {sendData?.plateType === "car" && (
            <div className={"car-tag"}>
              <p>پلاک / مولفه :</p>
              <ul className={"tag-number"}>
                <li>
                  <div className={"has-iran"}>{iran}</div>
                  <input
                    value={sendData?.partEight}
                    type={"number"}
                    id={"input-8"}
                    onChange={(e) => inputChanger(e.target.value, "partEight", 8)}
                    onKeyDown={(e) => handleBackspace(e, "partEight", 8)}
                  />
                  <input
                    value={sendData?.partSeven}
                    type={"number"}
                    id={"input-7"}
                    onChange={(e) => inputChanger(e.target.value, "partSeven", 7)}
                    onKeyDown={(e) => handleBackspace(e, "partSeven", 7)}
                  />
                </li>
                <li>
                  <input
                    value={sendData?.partSix}
                    type={"number"}
                    id={"input-6"}
                    onChange={(e) => inputChanger(e.target.value, "partSix", 6)}
                    onKeyDown={(e) => handleBackspace(e, "partSix", 6)}
                  />
                  <input
                    value={sendData?.partFive}
                    type={"number"}
                    id={"input-5"}
                    onChange={(e) => inputChanger(e.target.value, "partFive", 5)}
                    onKeyDown={(e) => handleBackspace(e, "partFive", 5)}
                  />
                  <input
                    value={sendData?.partFour}
                    type={"number"}
                    id={"input-4"}
                    onChange={(e) => inputChanger(e.target.value, "partFour", 4)}
                    onKeyDown={(e) => handleBackspace(e, "partFour", 4)}
                  />
                </li>
                <li
                  className={`tag-box ${openTag ? "open-tag" : ""}`}
                  onClick={() => {
                    setOpenTag(!openTag);
                    setFilterText("");
                  }}
                  ref={tagBoxRef}
                >
                  <input
                    value={openTag ? filterText : sendData?.partThree}
                    id={"input-3"}
                    onChange={(e) => {
                      setFilterText(e.target.value);
                      if (!openTag) {
                        setSendData({ ...sendData, partThree: e.target.value });
                      }
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => handleBackspace(e, "partThree", 3)}
                  />
                  {arrow}
                  <div className={"plate-list"}>
                    {filteredTags.map((item, index) => (
                      <div key={index + "tag"} className={"current-tag"}>
                        <p
                          onClick={() => {
                            setSendData({ ...sendData, partThree: item?.value });
                            setOpenTag(false);
                            document.getElementById("input-4").focus();
                          }}
                        >
                          {item.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </li>
                <li>
                  <input
                    value={sendData?.partTwo}
                    type={"number"}
                    id={"input-2"}
                    onChange={(e) => inputChanger(e.target.value, "partTwo", 2)}
                    onKeyDown={(e) => handleBackspace(e, "partTwo", 2)}
                  />
                  <input
                    value={sendData?.partOne}
                    type={"number"}
                    id={"input-1"}
                    onChange={(e) => inputChanger(e.target.value, "partOne", 1)}
                    onKeyDown={(e) => handleBackspace(e, "partOne", 1)}
                  />
                </li>
                <IranTagSVG />
              </ul>
            </div>
          )}

          {sendData?.plateType === "motor" && (
            <div className={"car-tag"}>
              <p>پلاک / مولفه :</p>
              <ul className={"tag-number"}>
                <li>
                  <input
                    value={sendData?.partEight}
                    type={"number"}
                    id={"input-8"}
                    onChange={(e) => inputChanger(e.target.value, "partEight", 8)}
                    onKeyDown={(e) => handleBackspace(e, "partEight", 8)}
                  />
                  <input
                    value={sendData?.partSeven}
                    type={"number"}
                    id={"input-7"}
                    onChange={(e) => inputChanger(e.target.value, "partSeven", 7)}
                    onKeyDown={(e) => handleBackspace(e, "partSeven", 7)}
                  />
                  <input
                    value={sendData?.partSix}
                    type={"number"}
                    id={"input-6"}
                    onChange={(e) => inputChanger(e.target.value, "partSix", 6)}
                    onKeyDown={(e) => handleBackspace(e, "partSix", 6)}
                  />
                  <input
                    value={sendData?.partFive}
                    type={"number"}
                    id={"input-5"}
                    onChange={(e) => inputChanger(e.target.value, "partFive", 5)}
                    onKeyDown={(e) => handleBackspace(e, "partFive", 5)}
                  />
                  <input
                    value={sendData?.partFour}
                    type={"number"}
                    id={"input-4"}
                    onChange={(e) => inputChanger(e.target.value, "partFour", 4)}
                    onKeyDown={(e) => handleBackspace(e, "partFour", 4)}
                  />
                </li>
                <li>
                  <input
                    value={sendData?.partThree}
                    type={"number"}
                    id={"input-3"}
                    onChange={(e) => inputChanger(e.target.value, "partThree", 3)}
                    onKeyDown={(e) => handleBackspace(e, "partThree", 3)}

                  />
                  <input
                    value={sendData?.partTwo}
                    type={"number"}
                    id={"input-2"}
                    onChange={(e) => inputChanger(e.target.value, "partTwo", 2)}
                    onKeyDown={(e) => handleBackspace(e, "partTwo", 2)}
                  />
                  <input
                    value={sendData?.partOne}
                    type={"number"}
                    id={"input-1"}
                    onChange={(e) => inputChanger(e.target.value, "partOne", 1)}
                    onKeyDown={(e) => handleBackspace(e, "partOne", 1)}
                  />
                </li>
                <IranTagSVG />
              </ul>
            </div>
          )}
        </>
      )}

      <DynaTextarea
        label={"آدرس"}
        name={"address"}
        style={{ height: "80px" }}
        className={"solid-dyna-input"}
        placeholder={"آدرس را وارد کنید"}
        value={sendData?.address}
        type={"text"}
        setDataFromComponent={(data) => {
          setSendData({ ...sendData, ...data });
        }}
      />

      <DynaInput
        label={"کد پستی"}
        name={"postalCode"}
        className={"solid-dyna-input"}
        placeholder={"کد پستی را وارد کنید"}
        value={sendData?.postalCode}
        type={"number"}
        setDataFromComponent={(data) => {
          setSendData({ ...sendData, ...data });
        }}
      />
    </div>
  );
};

export default InsuranceInformationStep;